import { 
  getBakeryArtworkNFTContract,
  getOneInchBakeNFTContract,
  getSeascapeNFTContract,
  getBakeryArtwork3NFTContract,
  getBakeryArtwork2NFTContract,
  getBakerySoccerContract,
  getTokocryptoNFTContract,
  getBmoncContract,
  getSfpNFTContract,
  getArtworkNftContract,
  getSoccerPokerGameBoxContract,
  getCarNFTContract,
  getDoggyNFTContract,
  getLoveNFTContract,
  getYooshiNFTContract,
  getRacaNFTContract,
  getPetEggNftContract,
  getWeaponNFTContract,
  getPetNftContract,
  getDishContract,
  getBinanceNftContract,
  getBondlyNftContract,
  getBscBakeNFTContract,
  getPokerCardContract,
  getBarkingNFTContract,
  getTokauNFTContract,
  getDoggyEquipmentContract,
  getMatrixPlusBoxContract,
  getToysContract,
  getKtaNFTContract,
  getNewDonghuangArtContract,
  getGaContract,
  getKRabbitContract,
  getKTreasureAdvancedContract,
  getKmoNFTContract
} from '../sushi/utils'

import { getBakeMuskMixerContract } from '../sushi/bakeMuskMixer'
import { getMuskUsmLandContract } from '../sushi/muskUsmLand'
import { MARKETTYPE, MARKETTYPEV1, MARKETTYPEV3, MARKETMULTITOKEN, NFTTYPE } from '../constants/bakery/nft'
import { MINTTOKEN } from '../constants/bakery'

export function userNFTContract(sushi: any, type?: string) {
  let contract = getDishContract(sushi)
  switch (type) {
    case MARKETTYPE.DISH:
    case NFTTYPE.COMBO_V2:
    case NFTTYPE.COMBO_V3:
    case MARKETTYPEV1.DISHV1:
    case MARKETTYPEV3.DISHV3:
      contract = getDishContract(sushi)
      break
    case MARKETTYPE.BAKERYARTWORK:
    case MARKETTYPEV1.BAKERYARTWORKV1:
    case MARKETTYPEV3.BAKERYARTWORKV3:
      contract = getBakeryArtworkNFTContract(sushi)
      break
    case MARKETTYPE.BTCARTWORK:
    case MARKETTYPEV1.BTCARTWORKV1:
    case MARKETTYPEV3.BTCARTWORKV3:
      contract = getArtworkNftContract(sushi)
      break
    case MARKETTYPE.ONEINCH:
    case MARKETTYPEV1.ONEINCHV1:
    case MARKETTYPEV3.ONEINCHV3:
      contract = getOneInchBakeNFTContract(sushi)
      break
    case MARKETTYPE.SEASCAPE:
    case MARKETTYPEV1.SEASCAPEV1:
    case MARKETTYPEV3.SEASCAPEV3:
      contract = getSeascapeNFTContract(sushi)
      break
    case MARKETTYPE.MEME:
    case MARKETTYPEV1.MEMEV1:
    case MARKETTYPEV3.MEMEV3:
      contract = getBakeryArtwork3NFTContract(sushi)
      break
    case MARKETTYPE.MUSKDOGE:
    case MARKETTYPEV1.MUSKDOGEV1:
    case MARKETTYPEV3.MUSKDOGEV3:
      contract = getBakeryArtwork2NFTContract(sushi)
      break
    case MARKETTYPE.BAKERYSOCCER:
    case MARKETTYPEV1.BAKERYSOCCERV1:
    case MARKETTYPEV3.BAKERYSOCCERV3:
    case NFTTYPE.SOCCER:
    case NFTTYPE.SOCCER_V2:
    case NFTTYPE.SOCCER_V3:
      contract = getBakerySoccerContract(sushi)
      break
    case MARKETTYPE.TKONFT:
    case MARKETTYPEV1.TKONFTV1:
    case MARKETTYPEV3.TKONFTV3:
      contract = getTokocryptoNFTContract(sushi)
      break
    case MARKETTYPE.SFPARTWORK:
    case MARKETTYPEV1.SFPARTWORKV1:
    case MARKETTYPEV3.SFPARTWORKV3:
      contract = getSfpNFTContract(sushi)
      break
    case MARKETTYPE.DOGGYNFT:
    case MARKETTYPEV1.DOGGYNFTV1:
    case MARKETTYPEV3.DOGGYNFTV3:
    case NFTTYPE.DOGGIES:
    case NFTTYPE.DOGGIES_V2:
    case NFTTYPE.DOGGIES_V3:
      contract = getDoggyNFTContract(sushi)
      break
    case MARKETTYPE.GAMEBOXNFT:
    case MARKETTYPEV3.GAMEBOXNFTV3:
    case NFTTYPE.GAMEBOX:
      contract = getSoccerPokerGameBoxContract(sushi)
      break
    case MARKETTYPE.CARNFT:
    case MARKETTYPEV3.CARNFTV3:
    case NFTTYPE.CAR:
    case NFTTYPE.CAR_V2:
    case NFTTYPE.CAR_V3:
      contract = getCarNFTContract(sushi)
      break
    case MARKETTYPE.LOVE:
    case MARKETTYPEV1.LOVEV1:
    case MARKETTYPEV3.LOVEV3:
      contract = getLoveNFTContract(sushi)
      break
    case MARKETTYPE.YOOSHINFT:
    case MARKETTYPEV1.YOOSHINFTV1:
    case MARKETTYPEV3.YOOSHINFTV3:
      contract = getYooshiNFTContract(sushi)
      break
    case MARKETTYPE.RACANFT:
    case MARKETTYPEV1.RACANFTV1:
    case MARKETTYPEV3.RACANFTV3:
    case MARKETMULTITOKEN.RACAMULTITOKEN:
      contract = getRacaNFTContract(sushi)
      break
    case MARKETTYPE.EGGNFT:
    case MARKETTYPEV1.EGGNFTV1:
    case MARKETTYPEV3.EGGNFTV3:
      contract = getPetEggNftContract(sushi)
      break
    case MARKETTYPE.WEAPONNFT:
    case MARKETTYPEV1.WEAPONNFTV1:
    case MARKETTYPEV3.WEAPONNFTV3:
      contract = getWeaponNFTContract(sushi)
      break
    case MARKETTYPE.PETNFT:
    case MARKETTYPEV1.PETNFTV1:
    case MARKETTYPEV3.PETNFTV3:
      contract = getPetNftContract(sushi)
      break
    case MINTTOKEN.TKONFTSTAKE:
      contract = getTokocryptoNFTContract(sushi)
      break
    case MINTTOKEN.BMONCNFTSTAKE:
    case MARKETTYPEV3.BINAMONV3:
      contract = getBmoncContract(sushi)
      break
    case MINTTOKEN.TOYNFTSTAKE:
      contract = getToysContract(sushi)
      break
    case MARKETTYPE.BINANCENFT:
    case MARKETTYPEV1.BINANCENFTV1:
    case MARKETTYPEV3.BINANCENFTV3:
      contract = getBinanceNftContract(sushi)
      break
    case MARKETTYPE.BONDLYNFT:
    case MARKETTYPEV1.BONDLYNFTV1:
    case MARKETTYPEV3.BONDLYNFTV3:
      contract = getBondlyNftContract(sushi)
      break
    case MARKETTYPE.BAKERYBSCARTWORK:
    case MARKETTYPEV1.BAKERYBSCARTWORKV1:
    case MARKETTYPEV3.BAKERYBSCARTWORKV3:
      contract = getBscBakeNFTContract(sushi)
      break
    case MARKETTYPE.POKERCARD:
    case MARKETTYPEV3.POKERCARDV3:
    case MARKETMULTITOKEN.POKERMULTITOKEN:
    case NFTTYPE.POKER:
    case NFTTYPE.POKER_V2:
    case NFTTYPE.POKER_V3:
      contract = getPokerCardContract(sushi)
      break
    case MARKETTYPE.BARKNFT:
    case MARKETTYPEV1.BARKNFTV1:
    case MARKETTYPEV3.BARKNFTV3:
    case NFTTYPE.BARKING:
    case NFTTYPE.BARKING_V2:
    case NFTTYPE.BARKING_V3:
      contract = getBarkingNFTContract(sushi)
      break
    case MARKETMULTITOKEN.TOKAUMULTITOKEN:
    case MARKETTYPEV3.TOKAUV3:
      contract = getTokauNFTContract(sushi)
      break
    case MARKETMULTITOKEN.EQUIPMENTMULTITOKEN:
    case MARKETTYPEV3.EQUIPMENTV3:
    case NFTTYPE.EQUIPMENT:
    case NFTTYPE.EQUIPMENT_V2:
    case NFTTYPE.EQUIPMENT_V3:
      contract = getDoggyEquipmentContract(sushi)
      break
    case MARKETMULTITOKEN.MATRIXMULTITOKEN:
    case MARKETTYPEV3.MATRIXV3:
    case NFTTYPE.MATRIX:
      contract = getMatrixPlusBoxContract(sushi)
      break
    case MARKETMULTITOKEN.TOYMULTITOKEN:
    case MARKETTYPEV3.TOYV3:
      contract = getToysContract(sushi)
      break
    case MARKETMULTITOKEN.KAKAMULTITOKEN:
    case MARKETTYPEV3.KAKAV3:
      contract = getKtaNFTContract(sushi)
      break
    case MARKETMULTITOKEN.BAKEMUSKMIXERMULTITOKEN:
    case MARKETTYPEV3.BAKEMUSKV3:
    case NFTTYPE.BAKEMUSKMIXER:
    case NFTTYPE.BAKEMUSKMIXER_V2:
    case NFTTYPE.BAKEMUSKMIXER_V3:
    case MINTTOKEN.BMMNFTSTAKE:
      contract = getBakeMuskMixerContract(sushi)
      break
    case MARKETTYPEV3.MUSKUSMLANDNFTV3:
      contract = getMuskUsmLandContract(sushi)
      break
    case MARKETTYPEV3.BLINV3:
      contract = getNewDonghuangArtContract(sushi)
      break
    case MARKETTYPEV3.GAV3:
      contract = getGaContract(sushi)
      break
    case MARKETTYPEV3.KTAV3:
      contract = getKTreasureAdvancedContract(sushi)
      break
    case MARKETTYPEV3.KRBV3:
      contract = getKRabbitContract(sushi)
      break
    case MARKETTYPEV3.KRIPTOMONV3:
      contract = getKmoNFTContract(sushi)
      break
  }
  return contract
}
